"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var mobx_1 = require("mobx");
function isPromiseLike(result) {
    return result && typeof result.then === "function";
}
exports.isPromiseLike = isPromiseLike;
var ComputedAsync = (function () {
    function ComputedAsync(options) {
        var _this = this;
        this.options = options;
        this.version = 0;
        this.busy = false;
        this.failed = false;
        this.atom = new mobx_1.Atom(options.name || "ComputedAsync", function () { return _this.wake(); }, function () { return _this.sleep(); });
        this.cachedValue = options.init;
    }
    ComputedAsync.prototype.wake = function () {
        var _this = this;
        this.sleep();
        this.monitor = this.options.delay !== undefined
            ? mobx_1.autorunAsync(function () { return _this.observe(); }, this.options.delay)
            : mobx_1.autorun(function () { return _this.observe(); });
    };
    ComputedAsync.prototype.observe = function () {
        var _this = this;
        var thisVersion = ++this.version;
        if (this.options.revert) {
            this.cachedValue = this.options.init;
            this.atom.reportChanged();
        }
        var current = function (f) { return function (arg) {
            if (_this.version === thisVersion)
                f(arg);
        }; };
        try {
            var possiblePromise = this.options.fetch();
            if (!isPromiseLike(possiblePromise)) {
                this.stopped(false, undefined, possiblePromise);
            }
            else {
                this.starting();
                possiblePromise.then(current(function (v) { return _this.stopped(false, undefined, v); }), current(function (e) { return _this.handleError(e); }));
            }
        }
        catch (x) {
            this.handleError(x);
        }
    };
    ComputedAsync.prototype.starting = function () {
        this.busy = true;
    };
    ComputedAsync.prototype.stopped = function (f, e, v) {
        this.busy = false;
        this.failed = f;
        this.error = e;
        if (v !== this.cachedValue) {
            this.cachedValue = v;
            this.atom.reportChanged();
        }
    };
    ComputedAsync.prototype.handleError = function (e) {
        var newValue = this.options.init;
        if (this.options.error) {
            try {
                newValue = this.options.error(e);
            }
            catch (x) {
                console.error(x);
            }
        }
        this.stopped(true, e, newValue);
    };
    ComputedAsync.prototype.sleep = function () {
        var monitor = this.monitor;
        this.monitor = undefined;
        if (monitor) {
            monitor();
        }
    };
    Object.defineProperty(ComputedAsync.prototype, "value", {
        get: function () {
            this.atom.reportObserved();
            if (this.failed && this.options.rethrow) {
                throw this.error;
            }
            return this.cachedValue;
        },
        enumerable: true,
        configurable: true
    });
    return ComputedAsync;
}());
__decorate([
    mobx_1.observable
], ComputedAsync.prototype, "busy", void 0);
__decorate([
    mobx_1.observable
], ComputedAsync.prototype, "failed", void 0);
__decorate([
    mobx_1.observable
], ComputedAsync.prototype, "error", void 0);
__decorate([
    mobx_1.action
], ComputedAsync.prototype, "starting", null);
__decorate([
    mobx_1.action
], ComputedAsync.prototype, "stopped", null);
function computedAsync(init, fetch, delay) {
    if (arguments.length === 1) {
        return new ComputedAsync(init);
    }
    return new ComputedAsync({
        init: init,
        fetch: fetch,
        delay: delay
    });
}
exports.computedAsync = computedAsync;
//# sourceMappingURL=computedAsync.js.map


//////////////////
// WEBPACK FOOTER
// ./~/computed-async-mobx/built/computedAsync.js
// module id = 664
// module chunks = 2